import { gql } from "@apollo/client";

export const GET_DATA_TIPO_MODULO = gql`
query GetDataTipoModulo($idTipoModulo: Int!) {
    dataTipoModulo(idTipoModulo: $idTipoModulo){
        success,
        error,
        valorEsperado {
          idTipoModulo,
          complejidad,
          seReporta,
          idTipoModuloReporta
        }
    }
}`;